export default "__VITE_ASSET__CLQEYL3k__"